import type { FC, ReactNode } from "react";

import classNames from "classnames";

import styles from "./ArticleRestrictedContentResponsiveContainer.module.scss";

type ArticleRestrictedContentResponsiveContainerProps = {
  children?: ReactNode;
  wrapperClassName?: string;
  contentClassName?: string;
};

export const ArticleRestrictedContentResponsiveContainer: FC<ArticleRestrictedContentResponsiveContainerProps> = ({
  children,
  wrapperClassName,
  contentClassName,
}) => {
  return (
    <div className={classNames(styles.wrapper, wrapperClassName)} data-testid="arcrc-wrapper">
      <div className={classNames(styles.content, contentClassName)} data-testid="arcrc-content">
        {children}
      </div>
    </div>
  );
};
